import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

import type { Apartment } from '@/integrations/supabase/fixedasset.models';

export type { Apartment };

export function useApartmentDetail(fixedAssetId: string | undefined) {
  return useQuery({
    queryKey: ['apartment-detail', fixedAssetId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('apartments')
        .select('*')
        .eq('fixed_asset_id', fixedAssetId!)
        .maybeSingle();
      if (error) throw error;
      return data as Apartment | null;
    },
    enabled: !!fixedAssetId,
  });
}
